import { formatDate } from '@/ui';
import { formatDuration } from '@/ui';
import {
  formatStatusLabel,
  getStatusChipColor,
  type StatusChipColor,
  type StatusChipStatus,
} from '@/ui';

export const formatExecutionStatusLabel = (status?: StatusChipStatus | null): string =>
  formatStatusLabel(status);

export const getExecutionStatusChipColor = (status?: StatusChipStatus | null): StatusChipColor =>
  getStatusChipColor(status);

export const formatExecutionTimestamp = (value: Date | string | null | undefined): string => {
  const resolvedValue = value instanceof Date || typeof value === 'string' ? value : null;
  return formatDate(resolvedValue, { includeTime: true });
};

export const formatExecutionDuration = (valueMs: number | null | undefined): string => {
  const formatted = formatDuration(valueMs);
  return formatted.length > 0 ? formatted : '-';
};
